import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 0;
  
  return (
    <div className="home-page">
      <div className="hero">
        <h1>California Tax Calculator {nextYear}</h1>
        <p>Your comprehensive solution for calculating California taxes accurately with up-to-date rates and county-specific information</p>
        <div className="hero-buttons">
          <Link to="/calculator" className="cta-button primary-cta">Calculate Taxes</Link>
          <Link to="/about" className="cta-button secondary-cta">Learn More</Link>
        </div>
      </div>
      
      <section className="tax-types">
        <h2 className="section-title">Complete Tax Calculation Suite</h2>
        <div className="tax-grid">
          <div className="tax-card">
            <div className="tax-icon sales-icon">💰</div>
            <h3>Sales Tax</h3>
            <p>Calculate precise sales tax for any purchase with county-specific rates across California</p>
            <div className="tax-card-footer">
              <span className="tax-feature">County Rates</span>
              <span className="tax-feature">Reverse Calculation</span>
            </div>
          </div>
          <div className="tax-card">
            <div className="tax-icon income-icon">📊</div>
            <h3>Income Tax</h3>
            <p>Estimate your state income tax liability based on California's progressive tax brackets</p>
            <div className="tax-card-footer">
              <span className="tax-feature">Multiple Filing Statuses</span>
              <span className="tax-feature">Latest Tax Brackets</span>
            </div>
          </div>
          <div className="tax-card">
            <div className="tax-icon property-icon">🏠</div>
            <h3>Property Tax</h3>
            <p>Calculate property taxes based on Proposition 13 rules and local assessment rates</p>
            <div className="tax-card-footer">
              <span className="tax-feature">County-Specific</span>
              <span className="tax-feature">Annual & Monthly</span>
            </div>
          </div>
        </div>
      </section>
      
      <section className="how-it-works">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Select Tax Type</h3>
            <p>Choose the type of California tax you need to calculate</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Enter Information</h3>
            <p>Provide the necessary details like income, purchase amount, or property value</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Get Results</h3>
            <p>Receive accurate tax calculations based on the latest California tax rates</p>
          </div>
        </div>
      </section>
      
      <section className="features">
        <h2 className="section-title">Why Choose Our Calculator</h2>
        <div className="features-grid">
          <div className="feature">
            <div className="feature-icon">✓</div>
            <h3>Up-to-Date</h3>
            <p>Using latest {nextYear} California tax rates and regulations</p>
          </div>
          <div className="feature">
            <div className="feature-icon">✓</div>
            <h3>Precise Calculations</h3>
            <p>County and city-specific rates for accurate results</p>
          </div>
          <div className="feature">
            <div className="feature-icon">✓</div>
            <h3>User-Friendly</h3>
            <p>Simple interface designed for ease of use</p>
          </div>
          <div className="feature">
            <div className="feature-icon">✓</div>
            <h3>No Registration</h3>
            <p>Free service with no sign-up required</p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <h2 className="section-title">What Users Are Saying</h2>
        <div className="testimonial-container">
          <div className="testimonial">
            <div className="quote-mark">"</div>
            <p>This calculator saved me so much time figuring out my tax obligations for multiple counties where I sell products.</p>
            <div className="testimonial-footer">
              <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Sarah K." className="testimonial-avatar" />
              <p className="author">Sarah K., <span>Small Business Owner</span></p>
            </div>
          </div>
          <div className="testimonial">
            <div className="quote-mark">"</div>
            <p>The most accurate and comprehensive sales tax calculator I've found for California. The county-specific information is invaluable.</p>
            <div className="testimonial-footer">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Michael T." className="testimonial-avatar" />
              <p className="author">Michael T., <span>Online Retailer</span></p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Ready to calculate your California taxes?</h2>
        <p>Get accurate estimates for sales tax, income tax, and property tax in seconds.</p>
        <Link to="/calculator" className="cta-button primary-cta">Start Calculating Now</Link>
      </section>
    </div>
  );
}

export default Home;
